import { NewdanhmuckhachhangService } from 'src/services/newdanhmuckhachhang.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const NEWDANHMUCKHACHHANG_NEW_CARE_SUCCESS = 'NEWDANHMUCKHACHHANG:NEW_CARE_SUCCESS'
export const NEWDANHMUCKHACHHANG_LIST_SUCCESS = 'NEWDANHMUCKHACHHANG:FIND_ALL_SUCCESS'
export const NEWDANHMUCKHACHHANG_LIST_FAILD = 'NEWDANHMUCKHACHHANG:FIND_ALL_FAILD'
export const NEWDANHMUCKHACHHANG_COUNT_ASSIGN_SUCCESS = 'NEWDANHMUCKHACHHANG:COUNT_ASSIGN_SUCCESS'
export const NEWDANHMUCKHACHHANG_COUNT_ASSIGN_FAILD = 'NEWDANHMUCKHACHHANG:COUNT_ASSIGN_FAILD'

export const NEWDANHMUCKHACHHANG_CREATE_SUCCESS = 'NEWDANHMUCKHACHHANG:CREATE_SUCCESS'
export const NEWDANHMUCKHACHHANG_CREATE_FAILD = 'NEWDANHMUCKHACHHANG:CREATE_FAILD'

export const NEWDANHMUCKHACHHANG_IMPORT_SUCCESS = 'NEWDANHMUCKHACHHANG:IMPORT_SUCCESS'
export const NEWDANHMUCKHACHHANG_SAVE_SUCCESS = 'NEWDANHMUCKHACHHANG:SAVE_SUCCESS'
export const NEWDANHMUCKHACHHANG_SAVE_FAILD = 'NEWDANHMUCKHACHHANG:SAVE_SUCCESS'

export const NEWDANHMUCKHACHHANG_DEL_SUCCESS = 'NEWDANHMUCKHACHHANG:DEL_SUCCESS'
export const NEWDANHMUCKHACHHANG_DEL_FAILD = 'NEWDANHMUCKHACHHANG:DEL_FAILD'

export const NEWDANHMUCKHACHHANG_ONE_SUCCESS = 'NEWDANHMUCKHACHHANG:FIND_ONE_SUCCESS'
export const NEWDANHMUCKHACHHANG_ONE_FAILD = 'NEWDANHMUCKHACHHANG:FIND_ONE_FAILD'

export const NEWDANHMUCKHACHHANG_HISTORY_LIST_SUCCESS = 'NEWDANHMUCKHACHHANG:HISTORY_FIND_ALL_SUCCESS'
export const NEWDANHMUCKHACHHANG_HISTORY_LIST_FAILD = 'NEWDANHMUCKHACHHANG:HISTORY_FIND_ALL_FAILD'

export const NEWDANHMUCKHACHHANG_UPDATE_FILTER = 'NEWDANHMUCKHACHHANG:NEWDANHMUCKHACHHANG_UPDATE_FILTER'

export const NEWDANHMUCKHACHHANG_LIST_EXPORT_SUCCESS = 'NEWDANHMUCKHACHHANG:FIND_ALL_EXPORT_SUCCESS'
export const NEWDANHMUCKHACHHANG_LIST_EXPORT_FAILD = 'NEWDANHMUCKHACHHANG:FIND_ALL_EXPORT_FAILD'

export const NEWDANHMUCKHACHHANG_UPDATE_HOMEPAGE_FILTER = 'NEWDANHMUCKHACHHANG:NEWDANHMUCKHACHHANG_UPDATE_HOMEPAGE_FILTER'

export const NEWDANHMUCKHACHHANG_HOMEPAGE_LIST_SUCCESS = 'NEWDANHMUCKHACHHANG:FIND_HOMEPAGE_LIST_SUCCESS'
export const NEWDANHMUCKHACHHANG_HOMEPAGE_LIST_FAILD = 'NEWDANHMUCKHACHHANG:FIND_HOMEPAGE_LIST_FAILD'

export const NEWDANHMUCKHACHHANG_HOMEPAGE_ONE_SUCCESS = 'NEWDANHMUCKHACHHANG:FIND_HOMEPAGE_ONE_SUCCESS'
export const NEWDANHMUCKHACHHANG_HOMEPAGE_ONE_FAILD = 'NEWDANHMUCKHACHHANG:FIND_HOMEPAGE_ONE_FAILD'

export const NEWDANHMUCKHACHHANG_ORDER_SUCCESS = 'NEWDANHMUCKHACHHANG:ORDER_SUCCESS'
export const NEWDANHMUCKHACHHANG_ORDER_FAILD = 'NEWDANHMUCKHACHHANG:ORDER_FAILD'

export const NEWDANHMUCKHACHHANG_GET_SIM_ANALYSIS_SUCCESS = 'NEWDANHMUCKHACHHANG:GET_SIM_ANALYSIS_SUCCESS'
export const NEWDANHMUCKHACHHANG_GET_SIM_ANALYSIS_FAILD = 'NEWDANHMUCKHACHHANG:GET_SIM_ANALYSIS_FAILD'

export const NEWDANHMUCKHACHHANG_HANDLE_IMPORT_ERRORS = 'NEWDANHMUCKHACHHANG:NEWDANHMUCKHACHHANG_HANDLE_IMPORT_ERRORS'

export const NewdanhmuckhachhangAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
    khachhangList,
}

function khachhangList() {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmuckhachhangService.khachhangList()
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmuckhachhangService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: NEWDANHMUCKHACHHANG_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { newdanhmuckhachhang } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageNewdanhmuckhachhangFilter } = newdanhmuckhachhang;
        const homepageNewdanhmuckhachhangPage = homepageNewdanhmuckhachhangFilter.homepageNewdanhmuckhachhangPage;
        const homepageNewdanhmuckhachhangLimit = homepageNewdanhmuckhachhangFilter.homepageNewdanhmuckhachhangLimit;

        return new Promise((resolve, reject) => {
            NewdanhmuckhachhangService.homepageList(homepageNewdanhmuckhachhangFilter).then((rs) => {
                if (!!homepageNewdanhmuckhachhangFilter && homepageNewdanhmuckhachhangFilter.homepageNewdanhmuckhachhangPage === 0) {
                    dispatch(success({
                        homepageNewdanhmuckhachhangItems: rs.data.values,
                        homepageNewdanhmuckhachhangTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmuckhachhang.homepageNewdanhmuckhachhangItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageNewdanhmuckhachhangLimit * homepageNewdanhmuckhachhangPage; i < homepageNewdanhmuckhachhangLimit * homepageNewdanhmuckhachhangPage + homepageNewdanhmuckhachhangLimit; i++) {
                        if (typeof rsDataValues[i - homepageNewdanhmuckhachhangLimit * homepageNewdanhmuckhachhangPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageNewdanhmuckhachhangLimit * homepageNewdanhmuckhachhangPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageNewdanhmuckhachhangItems: uniqueItems,
                        homepageNewdanhmuckhachhangTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: NEWDANHMUCKHACHHANG_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      NewdanhmuckhachhangService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { newdanhmuckhachhang } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmuckhachhang.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmuckhachhangService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(NewdanhmuckhachhangAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: NEWDANHMUCKHACHHANG_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: NEWDANHMUCKHACHHANG_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmuckhachhangService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { newdanhmuckhachhang } = getState();

            const { filter } = newdanhmuckhachhang;

            // Perform your asynchronous operation (e.g., API call)
            NewdanhmuckhachhangService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: NEWDANHMUCKHACHHANG_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { newdanhmuckhachhang } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = newdanhmuckhachhang;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            NewdanhmuckhachhangService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmuckhachhang.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: NEWDANHMUCKHACHHANG_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmuckhachhangService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(NewdanhmuckhachhangAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: NEWDANHMUCKHACHHANG_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_SAVE_FAILD, error } }
}

function create(payload, creatingFromAway = false) {
    return dispatch => {
        if (!creatingFromAway) dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.create(payload).then((rs) => {
            dispatch(success(rs));
            if (!creatingFromAway) dispatch(NewdanhmuckhachhangAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng mã!");
        }).finally(() => {
            if (!creatingFromAway) dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmuckhachhangAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng mã!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmuckhachhangAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_DEL_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(NewdanhmuckhachhangAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { newdanhmuckhachhang } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmuckhachhang.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhachhangService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHACHHANG_ORDER_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHACHHANG_ORDER_FAILD, error } }
}